import { Dialog } from '@strata/react-dialog';
import { FullscreenLoading } from '@strata/react-fullscreen-loading';
import { SuccessToast } from '@strata/react-toast-message';
import { useState } from 'react';

import { postClaimStatusCheck } from 'api/medbillingAPI';
import { handleError } from 'services/Error';
import { useRefetchAllClaimDetails } from 'store/api/medbillingApi';

const Title = 'Check Claim Status';

interface CheckClaimStatusDialogProps {
    onClose: () => void;
    payerId: string;
    transactionId: string;
    username: string | undefined;
}

export const CheckClaimStatusDialog = ({
    onClose,
    payerId,
    transactionId,
    username,
}: CheckClaimStatusDialogProps) => {
    const [isCheckingStatus, setIsCheckingStatus] = useState(false);

    const refetchAllClaimDetails = useRefetchAllClaimDetails({
        payerId,
        transactionId,
    });

    return (
        <>
            <FullscreenLoading
                isShowing={isCheckingStatus}
                loadingText={
                    <>
                        <p>Checking claim status.</p>
                        <p>
                            We appreciate your patience, this process could take up to one minute.
                        </p>
                    </>
                }
            />
            <Dialog
                dialogTitle={Title}
                isOpen={!isCheckingStatus}
                primaryButtonLabel="Yes, Check Status"
                onPrimaryButtonClick={() => {
                    void (async () => {
                        try {
                            setIsCheckingStatus(true);

                            await postClaimStatusCheck({ payerId, transactionId, username });

                            refetchAllClaimDetails();

                            SuccessToast({ message: 'Claim status check completed.' });

                            onClose();
                        } catch (err) {
                            handleError(
                                'Unable to check claim status. Please try again.',
                                err as Error,
                            );
                        } finally {
                            setIsCheckingStatus(false);
                        }
                    })();
                }}
                secondaryButtonLabel="No, Return To Claim"
                onSecondaryButtonClick={onClose}
                dialogContent={
                    <>
                        <p>
                            This will check for any status updates for the claim and any services.
                        </p>
                        <p>Are you sure you want to continue?</p>
                    </>
                }
            />
        </>
    );
};

CheckClaimStatusDialog.Title = Title;
